export const content={
  'zh-Hant': {
    nav: ['料亭','學院','血脈','旬之淵','關於'],
    rule: '校規第一條：以一期一會之鮮，獻未能言之心。',
    heroKicker: '淵是活的，會聞心。',
    heroLine: '以一期一會之鮮，獻未能言之心。',
    heroEn: 'ONE FRESHNESS,ONE MEETING. ONE HEART LEFT UNSAID.',
    heroSub: '客人預約之時，淵已發光。料理長聞淵而定題，是為おまかせ。先付組解題，板前下淵，尋回那份最新鮮的答案。',
    reserve: '入席 · ENTER',
    scroll: '向淵而下',
    banner: '同一份鮮不會回來，同一種心境也是。',
    institutionEyebrow: '01 · ITAMAE ACADEMY',
    institutionTitle: '裏・板前學院如何培養一名板前？',
    institutionBody: '表為百年料亭，裏為三年制板前學院。前兩年為共通基礎，習旬、習刀、習火候，學會不失手。第三年為專精，尋回自身血脈，養出自身手癖。畢業無試卷，僅有一席完整獻食。成，則可自立門戶，或留於表店為職人。',
    bloodlineEyebrow: '02 · BLOODLINE & KUSE',
    bloodline: '板前的血脈與手癖如何改變一席料理？',
    bloodlineIntro: '此為本學院最重要一課，請牢記。',
    roles: '其餘血脈 · 待下淵遇見',
    roleNote: '血脈，是你是誰；手癖，是你煮完後，客人成為誰。鮮度是客觀標準，而手癖只會在當日主廚獻食時發動。',
    abyssTitle: '旬之淵 · 百層',
    abyssIntro: '淵是活的，會聞心。客人預約時填寫問診票，淵已聞其心而發光。料理長憑技能「聞心」聽見淵之騷動，定下本次旬題。學院按發光區域，派隊下淵尋鮮。',
    aboutEyebrow: '04 · ABOUT OMAKASE.HK',
    aboutTitle: '誰在創作 OMAKASE.HK？',
    aboutTeamTitle: '關於我們',
    aboutTeamBody: 'OMAKASE.HK 由一群熱愛日本料理、敘事設計與互動世界建構的香港創作者共同策劃及維護。我們以一期一會為起點，將旬味、板前技藝與原創角色編織成可探索的雙語料理世界。',
    contactTitle: '如何聯絡 OMAKASE.HK？',
    contactBody: '如欲交流世界觀、提出內容勘誤、媒體合作或其他查詢，歡迎直接電郵與編輯團隊聯絡。',
    footer: '一期一會，一席一心。',
    soundOn: '聲音 開',
    soundOff: '聲音 關'
  },
  en: {
    nav: ['Ryotei','Academy','Bloodline','The Abyss','About'],
    rule: 'First Academy Rule: Offer the unspoken heart with once-in-a-lifetime freshness.',
    heroKicker: 'THE ABYSS LIVES. IT LISTENS TO THE HEART.',
    heroLine: 'Offer The Unspoken Heart With Once-In-A-Lifetime Freshness.',
    heroEn: 'ONE FRESHNESS,ONE MEETING. ONE HEART LEFT UNSAID.',
    heroSub: 'When a guest reserves,the Abyss begins to glow. The head chef listens,sets the seasonal question,and sends the academy below to retrieve its freshest answer.',
    reserve: 'ENTER · TAKE YOUR SEAT',
    scroll: 'Descend into the Abyss',
    banner: 'The same freshness never returns. Neither does the same state of heart.',
    institutionEyebrow: '01 · ITAMAE ACADEMY',
    institutionTitle: 'How Does The Secret Academy Train An Itamae?',
    institutionBody: 'The surface is a century-old ryotei;behind it stands a three-year itamae academy. Two years teach season,blade and fire. The final year awakens bloodline and personal Kuse. Graduation is not an exam,but one complete offering prepared alone.',
    bloodlineEyebrow: '02 · BLOODLINE & KUSE',
    bloodline: 'How Do Bloodline And Kuse Transform An Offering?',
    bloodlineIntro: 'This is the academy’s most important lesson. Remember it.',
    roles: 'Other Bloodlines · Awaiting Discovery',
    roleNote: 'Bloodline is who you are. Kuse is who the guest becomes after your cooking. Freshness remains objective;Kuse awakens only when the chef leads the offering.',
    abyssTitle: 'Shun no Fuchi · 100 Layers',
    abyssIntro: 'The Abyss lives and listens. When a guest completes the questionnaire,their heart illuminates a region below. The head chef hears its stirring,defines the seasonal question,and dispatches a team to retrieve the answer.',
    aboutEyebrow: '04 · ABOUT OMAKASE.HK',
    aboutTitle: 'Who Creates OMAKASE.HK?',
    aboutTeamTitle: 'About the team',
    aboutTeamBody: 'OMAKASE.HK is created and maintained by a Hong Kong team passionate about Japanese cuisine,narrative design and interactive world-building. Beginning with ichi-go ichi-e,we weave seasonal flavor,itamae craft and original characters into a bilingual culinary world.',
    contactTitle: 'How Can You Contact OMAKASE.HK?',
    contactBody: 'For world-building conversations,content corrections,media collaborations or other enquiries,email the editorial team directly.',
    footer: 'One meeting. One offering. One heart.',
    soundOn: 'Sound on',
    soundOff: 'Sound off'
  }
};

export const divisions=[
  {
    kanji: '先付',
    en: 'SAKIZUKE',
    zh: '解題組 · 觀問診票，解旬題，定派何隊下淵。學院之腦。',
    role: 'Puzzle Division · Reads the guest questionnaire,interprets the seasonal question and chooses the descent team.',
    seal: '壱'
  },
  {
    kanji: '向付',
    en: 'MUKOZUKE',
    zh: '攻擊組 · 以刀破路，負責切開與突破。紅澪屬此組。',
    role: 'Attack Division · Opens the way with the blade. Kuremio serves here.',
    seal: '弐'
  },
  {
    kanji: '焼物',
    en: 'YAKIMONO',
    zh: '防禦組 · 以火守鮮，負責穩住與守住。玉澄屬此組。',
    role: 'Defense Division · Protects freshness with fire. Tamasumi serves here.',
    seal: '参'
  },
  {
    kanji: '食事',
    en: 'SHOKUJI',
    zh: '輔助組 · 以米收束，連結整席，使其成為一段完整敘事。',
    role: 'Support Division · Uses rice to bind every course into one complete story.',
    seal: '肆'
  },
  {
    kanji: '水物',
    en: 'MIZUMONO',
    zh: '終結組 · 以甘味作結，負責餘韻，決定客人帶走何種心情。',
    role: 'Finisher Division · Shapes the final sweetness and the feeling the guest carries away.',
    seal: '伍'
  }
];

export const abyssStages=[
  {
    range: '01—29F',
    title: '淺層 · 洄游層',
    text: '光尚能抵達。鮭、鰤、鯵等當季洄游之鮮。'
  },
  {
    range: '030F',
    title: '問心之間',
    text: '安全層。白沙無風，存放歷代問診票。'
  },
  {
    range: '31—59F',
    title: '中層 · 深海層',
    text: '壓力使刀與心變形。鮪、鰻等需技法方能取得之鮮。'
  },
  {
    range: '060F',
    title: '守火之間',
    text: '安全層。黑鳥居隔開深海壓力，爐火不滅。'
  },
  {
    range: '61—89F',
    title: '深層 · 古法層',
    text: '失傳處理法與古老食材沉睡之處，需分辨傳承與執念。'
  },
  {
    range: '090F',
    title: '無心之間',
    text: '安全層。透明高湯無味，故能容萬味。'
  },
  {
    range: '91—100F',
    title: '神話層 · 血脈層',
    text: '先祖旬神沉睡處。需對應血脈共鳴方可進入，常人無法抵達。'
  }
];